import { useState } from 'react';
import Button from '../components/Button';
import Sidebar from '../components/Sidebar';
import stateData from '../stateData';
import "./gallery.css";


export const Gallery = ({currentState, setCurrentState}) => {
    const [sidebarExpanded, setSidebarExpanded] = useState(!currentState);
    const selectState = (value) => {
        setSidebarExpanded(false);
        setCurrentState(value);
    }
    return (
    <div className="gallery">
        <Sidebar states={stateData} selectedState={currentState} expanded={sidebarExpanded} selectState={selectState} />
        <div className="gallery-header">
            <Button onClick={() => setSidebarExpanded(true)}>Show state list</Button>
            {currentState && <h2>{currentState}</h2>}
            {currentState && <div>{stateData[currentState].year}</div>}
        </div>
        <div id="statePictures">
            {stateData[currentState] && stateData[currentState].photos.map(photo => {
            return photo.video ? (<video width="100%" controls autoplay>
                <source key={photo.url} src={photo.url} type="video/mp4"/>
                </video>) : <img key={photo.url} src={photo.url} />
            })}
        </div>
    </div>
    )
}